export const copy = {
  errors: {
    authToken: {
      invalidToken: "Invalid conversation token",
      identityNotFound: "No identity found on conversation",
      refreshFailed: "Failed to refresh token",
    },
    conversationNotFound: "Conversation could not be found",
    invalidConversationSid: "Invalid Conversation Identifier",
  },
};
